module.exports = __webpack_public_path__ + "static/media/new_member.f9220bf4.png";